import styled from 'styled-components';

import * as colors from 'components/common/colorConstants';
import { TicketTextBold } from 'components/common/fontElements';

export const Highlight = styled.span`
  background-color: ${(props) => props.color};
  color: white;
  font-size: 7px;
  padding: 3px 4px;
  margin-right: 6px;
  border-radius: 2.5px;
  line-height: 1;
`;

export const Text = styled(TicketTextBold)`
  margin: 0px !important;
  padding: 0px;
  display: inline-flex;
  align-items: ${(props) => (props.isLiveChat ? 'flex-end' : 'center')};
  line-height: 1;
  color: ${colors.lightBlack};
`;
